<script setup lang="ts">
import { provideInlineTable, type InlineTable, type ModuleConfiguration } from "@/vf"
import VfComposeInlineTable from "./VfComposeInlineTable.vue"

const props = withDefaults(
    defineProps<{
        config?: ModuleConfiguration
        inlineTable: InlineTable
        rowId: string
    }>(),
    {
        colspan: 1,
        config: undefined,
        filteredFieldGroups: undefined,
    },
)

if (props.inlineTable) {
    // make sure that child elements use the correct inline table
    provideInlineTable(props.inlineTable)
}
</script>

<template>
    <div class="compose-open-row">
        <VfComposeInlineTable v-bind="props">
            <template #default="{ loadedComponent }">
                <div class="compose-open-row-container" style="overflow: hidden">
                    <slot>
                        <component :is="loadedComponent.component" v-bind="loadedComponent.model"></component>
                    </slot>
                </div>
            </template>
        </VfComposeInlineTable>
    </div>
</template>

<style scoped>
.compose-open-row {
    background-color: #ebebeb;
    overflow: hidden !important;
}

.compose-open-row-container {
    margin: 0 2rem 2rem 2rem;
    background-color: white;
    padding: 2rem;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
}
</style>
